import React from 'react';
import { useP } from '../i18n/useP';
import '../styles/designSystem.css';

/* Navigation de période (‹ libellé ›) — zone 6 du standard de carte, posée
   AVANT le champ de recherche, qui reste le dernier élément à droite. */
export default function PeriodNav({ label, onPrev, onNext, prevDisabled = false, nextDisabled = false }) {
  const p = useP();
  return (
    <span className="lk-periodnav">
      <button type="button" onClick={onPrev} disabled={prevDisabled}
              title={p('Période précédente')} aria-label={p('Période précédente')}>‹</button>
      <em style={{ fontStyle: 'normal' }}>{label}</em>
      <button type="button" onClick={onNext} disabled={nextDisabled}
              title={p('Période suivante')} aria-label={p('Période suivante')}>›</button>
    </span>
  );
}
